import { PromptModel as PromptModelResponse } from '~/api/sylvanus/typedefs.autogen';
import { EntityType } from '~/enums/EntityType';
import { ModelResult } from '~/features/x-ray/types/model';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

interface Request {
  modelId: Uuid;
}

type Response = PromptModelResponse;

export const getModelResult = async ({
  modelId,
}: Request): Promise<ModelResult> => {
  const response: Response = await sylvanus.get(`/model/${modelId}`);

  return {
    currentOptimize: response.current_optimize
      ? {
          state: response.current_optimize.state,
          version: response.current_optimize.version_number,
        }
      : null,
    currentPublishStatus: response.current_publish?.status ?? null,
    id: response.id,
    latestVersion: response.version_numbers
      ? Math.max(...response.version_numbers)
      : 1,
    libraryModelId: response.library_model_info?.library_model_id,
    scope: [],
    targetEntity: {
      id: response.target_entity.id,
      type: EntityType.DocumentAttachedData,
    },
    versions: response.version_numbers ?? [],
  };
};
